const getBase64FromFile = file => {
    return new Promise((resolve, reject) => {
        const reader = new window.FileReader();

        reader.onload = () => {
            resolve(reader.result);
        };

        reader.onerror = () => reject;

        reader.readAsDataURL(file);
    });
}

const getImageFromPasteEvent = event => {
    return new Promise((resolve, reject) => {
        if (!event.clipboardData.items) {
            const waitInterval = setInterval(() => {
                if (event.target.children.length > 0) {
                    clearInterval(waitInterval);

                    resolve({
                        base64string: event.target.children[0].src,
                        type: getFileTypeFromBase64string(event.target.children[0].src)
                    });

                    event.target.innerHTML = '';
                }
            }, 1000);

            // Set max execution timeout
            setTimeout(() => {
                if (waitInterval) {
                    clearInterval(waitInterval);
                }
            }, 5000);
        } else {
            Array.from(event.clipboardData.items).some((item) => {
                if (item.kind === 'file' && (item.type === 'image/png' || item.type === 'image/jpeg')) {
                    const file = item.getAsFile();

                    const imageType = item.type;

                    getBase64FromFile(file).then((result) => {
                        resolve({
                            base64string: result,
                            type: imageType
                        });
                    });

                    return true;
                }
            });
        }
    });
}
const dataURItoBlob = dataURI => {
    // Convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
    }
    else {
        byteString = unescape(dataURI.split(',')[1]);
    }

    // Separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // Write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);

    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type:mimeString });
}

export const insertAtCaret = (element, text) => {
	var txtarea = element;
	var scrollPos = txtarea.scrollTop;
	var strPos = 0;
	var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
		"ff" : (document.selection ? "ie" : false ) );

	if (br == "ie") {
		txtarea.focus();
		var range = document.selection.createRange();
		range.moveStart ('character', -txtarea.value.length);
		strPos = range.text.length;
	}

	else if (br == "ff") strPos = txtarea.selectionStart;

	var front = (txtarea.value).substring(0,strPos);
	var back = (txtarea.value).substring(strPos,txtarea.value.length);
	txtarea.value=front+text+back;
	strPos = strPos + text.length;

	if (br == "ie") {
		txtarea.focus();
		var range = document.selection.createRange();

		range.moveStart ('character', -txtarea.value.length);
		range.moveStart ('character', strPos);
		range.moveEnd ('character', 0);
		range.select();
	}

	else if (br == "ff") {
		txtarea.selectionStart = strPos;
		txtarea.selectionEnd = strPos;
		txtarea.focus();
	}

	txtarea.scrollTop = scrollPos;
}

$(function() {
    const commentField = document.getElementById('comment-field');

    if(commentField) {
        const maxSize = 5; // mb
        const maxSizeBytes = maxSize * 1024 * 1024;

        commentField.onpaste = (event) => {
            getImageFromPasteEvent(event).then(res => {
                const projectToken = commentField.dataset.projectToken;
                const timestamp = new Date().getTime();
                const filename = timestamp + '.png';
                const blob = dataURItoBlob(res.base64string);
                const file = new File([blob], filename);
                const placeholder = `[![image](uploading:${filename})]()`;

                if(file.size > maxSizeBytes) {
                    alert(`Image can't be larger than ${maxSize}mb`);
                    return;
                }

                insertAtCaret(commentField, placeholder);

                const formData = new FormData();
                formData.append('file', file, filename);

                fetch(`/handle-js-file-clipboard-upload/${projectToken}?original_name=${filename}`, {
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('head meta[name="csrf-token"]')?.content,
                    },
                    method: "POST",
                    body: formData
                }).then(res => res.json()).then(res => {
                    const url = `[![image](${res.location})](${res.location})`;
                    const element = event.target;
                    const currentPosition = element.selectionEnd;
                    const newPosition = currentPosition + (url.length - placeholder.length);

                    element.value = element.value.replace(placeholder, url);

                    if (currentPosition > element.value.indexOf(url)) {
                        element.setSelectionRange(newPosition, newPosition);
                    } else {
                        element.setSelectionRange(currentPosition, currentPosition);
                    }

                    commentField.dispatchEvent(new Event("keyup"));
                    commentField.dispatchEvent(new Event("input"));
                })

            });
        };
    }

});
